import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { AlertCircle, ArrowLeft, Clock } from "lucide-react"

export default function PaymentFailedPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-[80vh] bg-gradient-to-b from-red-50 to-white">
      <div className="container max-w-4xl py-16 px-4">
        <div className="space-y-8 animate-fade-in">
          {/* Failed Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center">
              <AlertCircle className="w-10 h-10 text-red-600" />
            </div>
          </div>

          {/* Message */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold text-gray-900">
              Payment Processing Failed
            </h1>
            <p className="text-lg text-gray-600">
              We're sorry, but there was an issue processing your payment.
              Our team has been notified and we'll keep trying to resolve this.
            </p>
          </div>

          {/* Status Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card className="p-6 bg-muted hover:shadow-md transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                  <Clock className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">What's Next?</h3>
                  <p className="text-gray-600">
                    We'll automatically retry the payment and notify you of any updates
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6 bg-muted hover:shadow-md transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                  <ArrowLeft className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Need Help?</h3>
                  <p className="text-gray-600">
                    Contact our support team for assistance
                  </p>
                </div>
              </div>
            </Card>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <Button
              variant="outline"
              onClick={() => {
                const checkoutId = sessionStorage.getItem('retryUrl');
                window.location.href = `${checkoutId}?retry=true`;
              }}
              className="min-w-[200px]"
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate("/contact")}
              className="min-w-[200px]"
            >
              Contact Support
            </Button>
          </div>

          {/* Visual Elements */}
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
            <div className="absolute top-10 left-10 w-4 h-4 bg-red-200 rounded-full animate-ping" />
            <div className="absolute top-20 right-20 w-3 h-3 bg-red-100 rounded-full animate-ping" style={{ animationDelay: "0.2s" }} />
            <div className="absolute bottom-40 left-1/4 w-5 h-5 bg-red-100 rounded-full animate-ping" style={{ animationDelay: "0.4s" }} />
            <div className="absolute top-1/3 right-1/3 w-6 h-6 bg-red-50 rounded-full animate-ping" style={{ animationDelay: "0.6s" }} />
          </div>
        </div>
      </div>
    </div>
  )
}